export const SET_CATS_PAGE = 'viewer/cats/SET_CATS_PAGE';
export const SET_CATS_PAGE_ID = 'viewer/cats/SET_CATS_PAGE_ID';
export const SET_PAGINATION = 'pages/cats/SET_PAGINATION';
export const SELECT_OPTIONS = 'pages/cats/SELECT_OPTIONS';
export const RESELECT_OPTIONS = 'pages/cats/RESELECT_OPTIONS';
export const SET_CAT_QUIZ_VALUE = 'pages/cats/SET_CAT_QUIZ_VALUE';
export const SET_PAGES_TOTAL = 'pages/cats/SET_PAGES_TOTAL';
export const RESET_QUIZ_START_TIME = 'pages/cats/RESET_QUIZ_START_TIME';
export const SET_MONITORING_HISTORIES = 'viewer/cats/SET_MONITORING_HISTORIES';
export const SET_PAGE_QUIZ_RESULT_CACHE = 'pages/cats/SET_PAGE_QUIZ_RESULT_CACHE';
export const SET_PAGE_ANSWER_STATISTICS = 'pages/cats/SET_PAGE_ANSWER_STATISTICS';
export const SET_USER_QUESTIONS = 'pages/cats/SET_USER_QUESTIONS';
